import React, { useEffect } from 'react';
import { Box } from '@spothero/ui';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import SpotListItemTransient from 'pages/search-transient-event-monthly/components/spot-card-transient';
import SpotListItemMonthly from 'pages/search-transient-event-monthly/components/spot-card-monthly';
import SpotListComponent from 'common/spot-list';
import { useOnShowDetailsClick } from 'pages/search/hooks/use-on-show-details-click';
import { SearchPageView } from 'utils/search-page-view';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import SpotListItemAirport from 'pages/search-transient-event-monthly/components/spot-card-airport';
import { toggleShowTotal } from 'store/filters/filters-actions';
import { useDispatch } from 'react-redux';
const spotListMobileListViewStyles = {
    overflowY: 'auto',
    height: '100%',
};
export const SpotList = ({ loadMoreSpots }) => {
    const { spotsV2: spots, selectedSpotId, isPending, parkingType, view, } = useReduxSearchState();
    const showSpotListSorter = !useMobileBreakPoint();
    const onShowDetailsClick = useOnShowDetailsClick();
    const dispatch = useDispatch();
    // TODO: Handle event spots
    let SpotListItem = null;
    switch (parkingType) {
        case 'airport':
            SpotListItem = SpotListItemAirport;
            break;
        case 'monthly':
            SpotListItem = SpotListItemMonthly;
            break;
        case 'transient':
        default:
            SpotListItem = SpotListItemTransient;
            break;
    }
    const isSpotDetailsVisibleOnMobileMap = view === SearchPageView.MOBILE_MAP;
    useEffect(() => {
        if (parkingType === 'airport') {
            dispatch(toggleShowTotal(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parkingType]);
    return (<Box backgroundColor="gray.50" overflow={{ base: 'hidden', tablet: 'scroll' }} height={{ base: 'auto', tablet: 'desktop-search-body-height' }} // This is with the header height (desktop web), not to be kept and needs to be solved
     width={{ base: 'auto', tablet: '25%' }} minWidth={{ base: '0', tablet: '512px' }} // 512 to match prod but can be discussed
     sx={{
            '& > .SpotList': {
                // This is to ensure the spot list is NOT above the modal
                zIndex: isSpotDetailsVisibleOnMobileMap
                    ? 'layer3'
                    : 'unset',
                ...(view === SearchPageView.MOBILE_LIST
                    ? spotListMobileListViewStyles
                    : {}),
            },
        }}>
            <SpotListComponent spots={spots} selectedSpotId={selectedSpotId} onShowDetailsClick={onShowDetailsClick} showListLoader={isPending} showLoadingComplete={isPending} SpotListItem={SpotListItem} loadNextPage={loadMoreSpots} showSpotListSorter={showSpotListSorter} showMobileToggle={false}/>
        </Box>);
};
